import ImpactPill from "@/components/Impact/ImpactPill";
import Skeleton from "@/components/Skeleton/Skeleton";
import { CaretRightOutlined } from "@ant-design/icons";
import styles from "../ProductScenarios.module.scss";

export default function ProductScenarioSkeleton({ title }: { title?: string }) {
  return (
    <div className={`${styles.scenario}`}>
      <div className={styles.header}>
        <span className={styles.name}>
          <CaretRightOutlined />
          {title ? title : <Skeleton style={{ width: 90, height: 16 }} />}
        </span>
        <div className={styles.buttons}>
          <Skeleton style={{ width: 100, height: 32 }} />
        </div>
        <ImpactPill
          impact={undefined}
          loading={true}
        />
        <Skeleton style={{ width: 80, height: 24 }} />
      </div>
    </div>
  );
}
